<template>
  <div class="filters-list" @scroll="scrollHandler($event)">
    <filter-item
      v-for="(item, index) of filtersList"
      :key="`filter-item-${index}`"
      :filter-name="item"
      :is-active="item === activeFilter"
      @change-filter="changeFilterHandler"
    />
  </div>
</template>

<script>
import FilterItem from './components/filterItem';

export default {
  name: 'filters-list',

  components: {
    FilterItem,
  },

  data: () => ({
    filtersList: [],
    activeFilter: '',
  }),

  mounted() {
    if (window.accessoriesFilter) {
      this.filtersList = window.accessoriesFilter.sections;
      if (this.filtersList.length) {
        this.activeFilter = this.filtersList[0];
        this.$emit('change-filter', this.activeFilter);
      }
    }
  },

  methods: {
    changeFilterHandler(value) {
      this.activeFilter = value;
      this.$emit('change-filter', value);
    },
    scrollHandler(evt) {
      if (evt.target.scrollLeft / (evt.target.scrollWidth - evt.target.clientWidth) === 1) this.$emit('hide-background');
      else this.$emit('show-background');
    },
  },
};
</script>

<style scoped lang="scss">
.filters-list {
  display: flex;
  column-gap: 15px;
}
</style>
